// Mutations
export const RESETLOCKOUTS = 'RESETLOCKOUTS'
export const BINDLOCKOUTS = 'BINDLOCKOUTS'
export const UNBINDLOCKOUTS = 'UNBINDLOCKOUTS'
const BINDLOCKOUTCONTENT = 'BINDLOCKOUTCONTENT'
export const UNBINDLOCKOUTCONTENT = 'UNBINDLOCKOUTCONTENT'

const SETLOCKOUTATTRIBUTES = 'SETLOCKOUTATTRIBUTES'

// Actions
export const ADDLOCKOUT = 'ADDLOCKOUT';
export const EDITLOCKOUT = 'EDITLOCKOUT';
export const DELETELOCKOUT = 'DELETELOCKOUT';
export const SELECTLOCKOUT = 'SELECTLOCKOUT';

export const ADDTEAMTORAIDEVENT = 'ADDTEAMTORAIDEVENT';
export const REMOVETEAMFROMRAIDEVENT = 'REMOVETEAMFROMRAIDEVENT';

import db from '../../firebase/firebase';
import router from '../../router/router'
import { compareByKey } from '../../functions/general';
import {
  bindArray,
  bindArrayBase,
  bindArraySpecial,
  bindArrayWithBuffering,
  updateBoundObj } from '../helpers/binding';
import { generateUpdatesForObject } from '../helpers/updates'
import { localStorageSetKeyOrRemove } from '../../functions/general'
import { RESETSIGNUPS } from './signups'
import { RESETRAIDEVENTS } from './raidevents'
import { RESETTEAMS } from './teams'
import { RESETATTENDANCE } from './attendance'
import { snapshots2objects } from '../helpers/general'

export default {
  state: () => ({
    lockouts: [],
    selectedLockout: null,
    lockoutattributes: {},
  }),

  getters: {

  },

  mutations: {
    addBoundLockoutBatch: ( state, arrayOfSnapshots ) => {
      state.lockouts = state.lockouts
                            .concat( snapshots2objects( arrayOfSnapshots ) )
                            .sort( compareByKey )
                            .reverse()
    },
    removeBoundLockoutBatch: ( state, arrayOfSnapshots ) => {
      const keysToRemove = arrayOfSnapshots.map( snapshot => { return snapshot.key })
      state.lockouts = state.lockouts.filter( s => !keysToRemove.includes( s['.key'] ) )
    },
    updateBoundLockoutBatch: ( state, arrayOfSnapshots ) => {
      // We want to have an equivalent here of "updateBoundObj"
      // Otherwise the sort-order of lockouts is broken
      // (if we would build it like updateBoundSignupBatch)
      for( let snapshot of arrayOfSnapshots ) {
        updateBoundObj( state.lockouts, snapshot)
      }
      // const arrayOfObjects = snapshots2objects( arrayOfSnapshots )
      // state.lockouts = state.lockouts.filter( s => !arrayOfObjects.find( obj => obj['.key'] == s['.key'] ) )
      //                                .concat( arrayOfObjects )
    },

    setSelectedLockout( state, lockout ) {
      state.selectedLockout = lockout
      state.lockoutattributes = {}

      // Remember last selected lockout in localStorage
      localStorageSetKeyOrRemove( 'lastSelectedLockout', lockout )
    },

    [RESETLOCKOUTS] ( state ) {
      state.lockouts = []
      state.selectedLockout = null
      state.lockoutattributes = {}
    },

    [SETLOCKOUTATTRIBUTES]: ( state, newattributes ) => {
      state.lockoutattributes = newattributes
    },
    
  },

  actions: {
    [BINDLOCKOUTS] ( { commit }, destination ) {
      const lockoutsRef = db.ref( 'destinationLockouts/' +
                                  destination['.key'] +
                                  '/lockouts' )
      // bindArray( lockoutsRef, commit, 'Lockout' )
      bindArrayWithBuffering( lockoutsRef, commit, 'Lockout' )
    },
    [UNBINDLOCKOUTS] ( { rootState } ) {
      let destination = rootState.destinations.selectedDestination
      if( destination ) {
        const lockoutsRef = db.ref( 'destinationLockouts/' + destination['.key'] + '/lockouts' )
        lockoutsRef.off()
      }
    },

    [ADDLOCKOUT] ( context, { destination, lockout } ) {
      if( destination ) {
        db.ref( 'destinationLockouts/' + destination['.key']
                + '/lockouts' ).push( lockout )
      }
    },
    [EDITLOCKOUT] ( context, { destination, lockout, newvalues } ) {
      if( destination && lockout ) {
        let updates = generateUpdatesForObject(
          'destinationLockouts/' + destination['.key'] +
          '/lockouts/' + lockout['.key'] + '/', newvalues )
        return db.ref().update( updates )
      }
    },
    [DELETELOCKOUT] ( context, { destination, lockout } ) {
      if( destination && lockout ) {
        let updates = {}
        updates[ 'lockouts/' + lockout['.key'] ] = null
        updates[ 'destinationLockouts/' + destination['.key'] 
                 + '/lockouts/' + lockout['.key'] ] = null
        return db.ref().update( updates )
      }
    },
    async [SELECTLOCKOUT] ( { commit, dispatch }, lockout ) {
      await dispatch( UNBINDLOCKOUTCONTENT )

      commit( RESETSIGNUPS )
      commit( RESETRAIDEVENTS )
      commit( RESETTEAMS )
      commit( RESETATTENDANCE )

      commit( 'setSelectedLockout', lockout )

      if( lockout ) {
        dispatch( BINDLOCKOUTCONTENT, lockout )
      }
      router.push( '/roster' )
    },

    async [BINDLOCKOUTCONTENT] ( { commit, rootState }, lockout ) {
      // Bind the /attributes of the lockout
      const attributesRef = db.ref( 'lockouts/' + lockout['.key'] + '/attributes' )
      attributesRef.on( 'value' , ( snapshot ) => {
        commit( SETLOCKOUTATTRIBUTES, snapshot.val() )
      })

      // For RaidEvents, we need a special argument, the raidduration
      let destination = rootState.destinations.selectedDestination
      let raidduration = 180
      if( destination && destination.raidduration ) raidduration = destination.raidduration

      // Bind RaidEvents, Teams and Signups
      const raideventsRef = db.ref( 'lockouts/' + lockout['.key'] + '/raidevents' )
      await bindArraySpecial( raideventsRef, commit, 'RaidEvent', raidduration )
      const teamsRef = db.ref( 'lockouts/' + lockout['.key'] + '/teams' )
      await bindArray( teamsRef, commit, 'Team' )
      const signupsRef = db.ref( 'lockouts/' + lockout['.key'] + '/signups' )
      return bindArrayBase( signupsRef, commit, 'Signup', true, true, false, null )
      // return bindArrayWithBuffering( signupsRef, commit, 'Signup' )
    },
    [UNBINDLOCKOUTCONTENT] ( { state } ) {
      let lockout = state.selectedLockout
      if( lockout ) {
        const attributesRef = db.ref( 'lockouts/' + lockout['.key'] + '/attributes' )
        attributesRef.off()
        const raideventsRef = db.ref( 'lockouts/' + lockout['.key'] + '/raidevents' )
        raideventsRef.off()
        const teamsRef = db.ref( 'lockouts/' + lockout['.key'] + '/teams' )
        teamsRef.off()
        const signupsRef = db.ref( 'lockouts/' + lockout['.key'] + '/signups' )
        signupsRef.off()
      }
    },

    [ADDTEAMTORAIDEVENT] ( context, { lockout, team, raidevent } ) {
      if( lockout ) {
        var updates = {}
        updates['/raidevents/' + raidevent['.key'] +
                '/teams/' + team['.key'] ] = true
        updates['/teams/' + team['.key'] +
                '/raidevents/' + raidevent['.key'] ] = true
        return db.ref( 'lockouts/' + lockout['.key'] ).update( updates )
      }
    },
    [REMOVETEAMFROMRAIDEVENT] ( { rootState }, { lockout, team, raidevent } ) {
      if( lockout ) {
        var updates = {}

        // Remove Event.Team and Team.Event
        updates['/raidevents/' + raidevent['.key'] +
                '/teams/' + team['.key'] ] = null
        updates['/teams/' + team['.key'] +
                '/raidevents/' + raidevent['.key'] ] = null

        // Remove all signups for this team/event combi
        let teameventsigns = rootState.signups.signups.filter(
          s => s.team == team['.key'] && s.eventid == raidevent['.key'] )
          
        for( var sign of teameventsigns ) {
          updates[ '/signups/' + sign['.key'] + '/team' ] = null
          updates[ '/signups/' + sign['.key'] + '/state' ] = null
        }
        
        return db.ref( 'lockouts/' + lockout['.key'] ).update( updates )
      }
    },

  },
}